import React from "react"

import {
	Box,
	Divider,
	List,
	ListItemButton,
	Pagination,
	Stack,
	Typography,
} from "@mui/material"
import {
	TabContext,
	TabPanel,
} from "@mui/lab"

import { t } from "@lingui/macro"

import {
	PaginatedResponse,
	PaginationInfo,
	Workflow,
} from "models"
import {
	SbTab,
	SbTabList,
} from "components/commons"

import { WorkflowComponentPreview } from "../../detail/workflow-component-preview"

interface WorkflowColumnOneProps {
	handlePagination: (value: number) => void
	onItemSelected: (workflow: Workflow) => void
	openAssignWorkflowDialog: (workflow: Workflow) => void
	openDeleteWorkflowDialog: (workflow: Workflow) => void
	assignWorkflow: (workflowId: string, userId: string) => void
	selectedWorkflowId: string | null
	workflowsData: PaginatedResponse<Workflow>
}
interface WorkflowColumnOneState {
}
export class WorkflowColumnOne extends React.Component<WorkflowColumnOneProps, WorkflowColumnOneState> {
	private handlePagination = (_: React.ChangeEvent<unknown>, value: number) => {
		this.props.handlePagination(value)
	}

	render() {
		const items: Workflow[] = this.props.workflowsData?.items ?? []
		const pagination: PaginationInfo | undefined = this.props.workflowsData?.pagination

		return (
			<TabContext value="1">
				<Box sx={{ borderBottom: 0 }}>
					<SbTabList variant="fullWidth">
						<SbTab
							disableRipple
							disableTouchRipple
							label={t({ id: "workflow.workflows", message: "Workflows", })}
							value="1" />
					</SbTabList>
				</Box>
				<TabPanel value="1" sx={{ px: 0, }}>
					<Stack direction="column" alignItems="center">
						{items.length !== 0 &&
							<Pagination
								showFirstButton
								showLastButton
								page={(pagination?.currentPage ?? 0) + 1}
								count={pagination?.totalPages ?? 1}
								onChange={this.handlePagination} />
						}
						{items.length === 0 ?
							<Typography sx={{ pt: 5 }}>Nessun workflow disponibile</Typography> :
							<List sx={{ width: "100%", height: "52vh", overflow: "auto" }}>
								{items.map((data: Workflow) => (
									<Box key={data.id}>
										<ListItemButton
											key={data.id}
											onClick={() => this.props.onItemSelected(data)}
											selected={this.props.selectedWorkflowId === data.id}
										>
											<WorkflowComponentPreview
												data={data}
												openAssignDialog={this.props.openAssignWorkflowDialog}
												openDeleteDialog={this.props.openDeleteWorkflowDialog}
											/>
										</ListItemButton>
										<Divider />
									</Box>
								))}
							</List>
						}
					</Stack>
				</TabPanel>
			</TabContext>
		)
	}
}
